import { router } from "@/router";
import NotificacaoService from "@/services/NotificacaoService";
export const actions = {
  listarNotificacao: ({ commit, dispatch }) => {
    NotificacaoService.listar()
      .then((res) => {
        commit("setNotificacoes", res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  },
  visualizarNotificacao: ({ commit, dispatch }, notificacao) => {
    commit("setOverlay", true);
    NotificacaoService.visualizar(notificacao)
      .then((res) => {
        commit("removeNotificacao", notificacao);
        commit("setOverlay", false);
        router.push({name: notificacao.url});
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
};

export default {};
